import { useEffect, useState } from 'react';

const useHeaderHeight = (userSubscription: string | null) => {
  const [headerHeight, setHeaderHeight] = useState(0);

  useEffect(() => {
    const calculateHeaderHeight = () => {
      const header = document.getElementById('DashboardHeader');
      const upgradeTopBanner =
        userSubscription === 'bizzy_free' ? document.querySelector('.topBanner') : null;

      if (header) {
        const headerEl = header as HTMLElement;
        const upgradeTopBannerEl = upgradeTopBanner as HTMLElement | null;
        const height = upgradeTopBannerEl
          ? upgradeTopBannerEl.offsetHeight + headerEl.offsetHeight
          : headerEl.offsetHeight;

        setHeaderHeight(height);
      }
    };

    calculateHeaderHeight();

    window.addEventListener('resize', calculateHeaderHeight);

    return () => {
      window.removeEventListener('resize', calculateHeaderHeight);
    };
  }, [userSubscription]);

  return headerHeight;
};

export default useHeaderHeight;
